// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#location-name{
    width:100%;
}

.location-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.location-website{
    overflow-x:scroll;
}

.edit-location, .delete-location, .superuser-request, .report-loc-button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 5px;
    padding-left: 10px;
    padding-right:10px;
    margin: 2px;
    cursor: pointer;
    border-radius: 15px;
}

.report-loc-button{
    background-color: rgb(127, 135, 153);

}

.report-loc-button:hover{
    background-color: rgb(92, 98, 111);
}

.edit-location:hover{
    background-color: rgba(34, 43, 172, 0.871);
}

.delete-location{
    background-color: rgba(234, 13, 9, 0.884);
}

.delete-location:hover{
    background-color: rgba(106, 11, 10, 0.884);
}
`, "",{"version":3,"sources":["webpack://./src/css/location.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;;AAExC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;AAC9C","sourcesContent":["#location-name{\n    width:100%;\n}\n\n.location-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.location-website{\n    overflow-x:scroll;\n}\n\n.edit-location, .delete-location, .superuser-request, .report-loc-button {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 5px;\n    padding-left: 10px;\n    padding-right:10px;\n    margin: 2px;\n    cursor: pointer;\n    border-radius: 15px;\n}\n\n.report-loc-button{\n    background-color: rgb(127, 135, 153);\n\n}\n\n.report-loc-button:hover{\n    background-color: rgb(92, 98, 111);\n}\n\n.edit-location:hover{\n    background-color: rgba(34, 43, 172, 0.871);\n}\n\n.delete-location{\n    background-color: rgba(234, 13, 9, 0.884);\n}\n\n.delete-location:hover{\n    background-color: rgba(106, 11, 10, 0.884);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
